import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { Wrap } from "~/features/ui/wrap";
import { takeFirst } from "~/features/app/utils";
type SpacerBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  hasSolidBackground?: boolean | null;
  hasTopDivider?: boolean | null;
  isBig?: boolean | null;
  isHighlighted?: boolean | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"div"> & Record<`data-${string}`, string | undefined>;
  theme?: string | null;
};
export function SpacerBlockView({
  anchor,
  hasSolidBackground = false,
  hasTopDivider = true,
  isBig = false,
  isHighlighted = false,
  mode = "light",
  sectionProps,
  theme = "white"
}: SpacerBlockViewProps) {
  return <_StyledDiv {...sectionProps} data-theme={mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  },
  // v3: white theme renders true white (was hardcoded grey); grey stays grey.
  theme === "grey" ? {
    "backgroundColor": "var(--bg-secondary)"
  } : {
    "backgroundColor": "var(--bg-primary)"
  }, isHighlighted && {
    "backgroundColor": "var(--white-static)"
  }, hasSolidBackground && {
    "position": "relative"
  }]}>
      <_StyledWrap>
        <_StyledDiv2 $_css2={[isBig ? {
        "height": "var(--spacing-4xl)"
      } : {
        "height": "var(--spacing-3xl)"
      }]} />
      </_StyledWrap>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1gcz5jz-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-1gcz5jz-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv2 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "spacer___StyledDiv2",
  componentId: "sc-3ziz8p-0"
})(["", ""], p => p.$_css2);